module.exports = __webpack_public_path__ + "img/features03-04.781003e.webp";